import { render, staticRenderFns } from "./SVC31200.vue?vue&type=template&id=f637975c&"
import script from "./SVC31200.vue?vue&type=script&lang=js&"
export * from "./SVC31200.vue?vue&type=script&lang=js&"
import style0 from "./SVC31200.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports